var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2157,
    height: 2235,
    viewBox: "0 0 2157 2235",
    fill: "#FFF",
    id: "svg534",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g505",
    transform: "matrix(.94308 0 0 .94308 61.388 63.6105)",
    strokeWidth: 35.4818,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.311 1355.89c-157.94 253.73-315.881 507.29-473.821 761.01-50.912 84.19-145.578 129.62-236.341 114.21C81.1683 2212.61-3.4135 2109.6.0023 1988.09L.9782 227.766C6.3459 116.803 87.8373 23.6848 196.492 3.8931 302.708-15.574 410.062 39.7453 456.256 138.217l437.711 743.161C707.074 747.217 520.343 613.217 333.45 479.056c1.627 424.71 3.09 849.584 4.717 1274.294 187.381-132.54 374.763-264.92 562.307-397.46z",
    id: "path501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.53 1356.7c157.94 253.73 315.88 507.29 473.82 761.01 50.91 84.2 145.58 129.62 236.34 114.21 109.14-18.5 193.56-121.51 190.15-243.02l-.82-1760.322c-5.36-110.963-86.85-204.0817-195.51-223.8734-106.21-19.4672-213.57 35.8522-259.76 134.3244L1263.04 882.19c186.89-134.162 373.62-268.161 560.51-402.323-1.62 424.71-3.09 849.583-4.71 1274.293-187.39-132.54-374.77-264.92-562.31-397.46z",
    id: "path503"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs532"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_931_1407",
    x1: 989.61,
    y1: 1122.29,
    x2: -403.388,
    y2: 1112.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5",
    id: "stop507"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D1D1D1",
    id: "stop509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EAEAEA",
    id: "stop511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9F9F9",
    id: "stop513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    id: "stop515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_931_1407",
    x1: 1167.56,
    y1: 1123.26,
    x2: 2560.39,
    y2: 1113.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5",
    id: "stop518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D1D1D1",
    id: "stop520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EAEAEA",
    id: "stop522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9F9F9",
    id: "stop524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    id: "stop526"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_1407"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2157v2235H0z",
    id: "path529"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1751807aad8796e8b248edd001b8d03e.svg";
export { ForwardRef as ReactComponent };